import React, { useEffect, useState } from 'react';
import useClassiUtenti from '../../../hooks/useClassiUtenti';

export default function TicketManagerForm({
  formTicketManager,
  setFormTicketManager,
  showModalTicketManager,
  isUpdate = false,
}) {
  const { getClassiUtenteByToken } = useClassiUtenti();
  const [classi, setClassi] = useState([]);
  const [isLoading, setIsLoading] = useState(!isUpdate);

  useEffect(() => {
    if (!showModalTicketManager) {
      setFormTicketManager({});
    }
  }, [showModalTicketManager]);

  useEffect(() => {
    if (!isUpdate) {
      fetchClassi();
    }
  }, []);

  const fetchClassi = async () => {
    setIsLoading(true);
    try {
      const classiData = await getClassiUtenteByToken();
      setClassi(classiData);
    } catch (error) {
      console.error('Error fetching classi:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormTicketManager(prevState => ({ ...prevState, [name]: value }));
  };

  if (isLoading) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center" style={{minHeight: '200px'}}>
        <div className="spinner-border text-primary mb-3" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>Caricamento corsi in corso...</p>
      </div>
    );
  }

  return (
    <div className="container">
      {!isUpdate && (
        <div className='row'>
          <div className='col-sm-12 my-2'>
            <span className='small text-muted d-block mb-1'><b>Corso</b></span>
            <select
              name="id_classe"
              value={formTicketManager.id_classe || ''}
              onChange={handleInputChange}
              className="form-control"
            >
              <option value="">Seleziona un corso</option>
              {classi.map((classe) => (
                <option key={classe.id_classe} value={classe.id_classe}>
                  {classe.denominazione_corso}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}
      <div className='row'>
        <div className='col-sm-12 my-2'>
          <span className='small text-muted d-block mb-1'><b>Oggetto</b></span>
          <input 
            name="oggetto" 
            value={formTicketManager.oggetto || ''} 
            onChange={handleInputChange} 
            className="form-control" 
            type="text" 
            placeholder="Oggetto del ticket"
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-sm-12 my-2'>
          <span className='small text-muted d-block mb-1'><b>Descrizione</b></span>
          <textarea 
            name="descrizione"
            value={formTicketManager.descrizione || ''}
            onChange={handleInputChange}
            className="form-control"
            rows="5"
            placeholder="Descrizione del ticket"
          />
        </div>
      </div>
    </div>
  );
}
